module.exports = {"medical-assistance":{"meta-title":"Online medical assistance"},"title":"Free choice of the best professionals, at any time and from anywhere","general":"General Medicine and Family","pediatrics":"Pediatrics","alert":"Receive the recipe on your mobile!","hire-now-with-price":"Hire for 11.95 euros/month 2 adults + 2 children included","more-info-btn":"More information"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/public/views/primesalud-medical-assistance.json
// module id = 531
// module chunks = 117